export default {
  ERROR: 'readingAreaError'
};
